export enum SecurityStatusName {
  PendingApproval = 'Pending approval',
  Approved = 'Approved',
  Rejected = 'Rejected',
  InformationRequired = 'Information required',
}
